export const DEFAULT_IMAGE_CONTAINER = { width: 50, height: 50 };
export const SIDE_PADDING = 20;

export enum DataHooks {
  ROOT = 'body-root',
  DEPRECATED_GRID = 'body-grid',
}
